import { GetRejectedList } from "@/services/application.service";
import type { ApplicationData } from "@/types/Application/application";
import { message } from "antd";
import { useEffect, useState } from "react";

export function useApplicationRejected() {
  const [loading, setLoading] = useState(true);
  const [applicationRejectedList, setApplicationRejectedList] =
    useState<ApplicationData | null>(null);

  const fetchRejectedList = async (
    search = "",
    pageNumber = 1,
    pageSize = 25,
    categoryKey = "",
    dateFrom = "",
  ) => {
    try {
      setLoading(true);

      const response = await GetRejectedList({
        pageNumber,
        pageSize,
        search,
        dateFrom,
        categoryKey,
      });

      setApplicationRejectedList(response.data);
    } catch (error) {
      message.error(
        error instanceof Error
          ? error.message
          : "Gagal mendapatkan senarai permohonan",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRejectedList();
  }, []);

  return {
    fetchRejectedList,
    loading,
    applicationRejectedList,
  };
}